/**
 * Company: SPHMedia
 * Description: [Budget 2026 PDF link banner]
 */

import budgetLogo from "@assets/budget2026/budget2026.svg";
import pdfDownloadIcon from "@assets/budget2026/pdf-download-icon.svg";
import pdfImg from "@assets/budget2026/pdf-img.svg";
import { budgetPDFLink } from "@config/budgetPDF";
import Link, { LinkRel } from "@elements/Typography/Link";
import { ReactElement } from "react";

/**
 * BudgetPDFBanner
 * Description: [Budget 2026 PDF link banner component]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function BudgetPDFBanner(): ReactElement {
  // Add component logic and state here

  return (
    <div
      className="border-border-strong border-t border-b bg-budget-mobile md:bg-budget-tablet lg:bg-budget-desktop
        bg-no-repeat md:bg-[position:60px_center] my-5 md:my-4 lg:my-4.5"
    >
      <div className="flex gap-4 items-center md:justify-center py-2">
        <div className="flex items-center shrink-0">
          <Link
            destination={budgetPDFLink}
            relativePath={false}
            target="_blank"
            rel={LinkRel.NOOPENER}
          >
            <img src={pdfImg} alt="Budget2026-img" width={103} height={80} />
          </Link>
        </div>
        <div className="flex flex-col justify-start">
          <img src={budgetLogo} alt="Budget2026-logo" width={88} height={30} />
          <Link
            destination={budgetPDFLink}
            relativePath={false}
            target="_blank"
            rel={LinkRel.NOOPENER}
          >
            <span className="text-blue-100 font-primary text-md font-bold leading-[150%]">
              Muat turun Buku Belanjawan Perniagaan MTI 2026
              <img
                src={pdfDownloadIcon}
                alt="pdf-download-icon"
                width={21}
                height={21}
                className="inline ml-0.5 align-text-bottom"
              />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
